import { makeSelectors } from '@utils/css';

const listboxModifiers = makeSelectors({
  uncolored: "dibu1tjj5dj"
});

export { listboxModifiers };
import "./_shared.style.linaria.module.css";
//# sourceMappingURL=_shared.style.js.map
